'use client';

import { useState, useEffect, useRef } from "react";
import styles from "./DropdownTags.module.css";

export default function DropdownTags({ sortBy, onChange }) {
    const [isOpen, setIsOpen] = useState(false);
    const selectorRef = useRef(null);

    const toggleOpen = () => setIsOpen(!isOpen);

    // Fermer le menu si clic en dehors
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (selectorRef.current && !selectorRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div>
            <label htmlFor="dropdown" className={styles.label}>Trier par</label>
            <div className={styles.dropdown} ref={selectorRef} id="dropdown">
                <button className={styles.selected} onClick={toggleOpen}>
                    {sortBy}
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 448 512"
                        className={`${styles.icon} ${isOpen ? styles.open : ""}`}
                        fill="white"
                    >
                        <path d="M201.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 338.7 54.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>
                    </svg>
                </button>

                {isOpen && (
                    <ul className={styles.menu}>
                        <li
                            onClick={() => {
                                onChange("Popularité");
                                setIsOpen(false);
                            }}
                        >
                            Popularité
                        </li>
                        <li
                            onClick={() => {
                                onChange("Date");
                                setIsOpen(false);
                            }}
                        >
                            Date
                        </li>
                        <li
                            onClick={() => {
                                onChange("Titre");
                                setIsOpen(false);
                            }}
                        >
                            Titre
                        </li>
                    </ul>
                )}
            </div>
        </div>
    );
}
